enum ReimbursementStatus {
  NOT_APPLICABLE = "NOT_APPLICABLE",
  NOT_COMPLETED = "NOT_COMPLETED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PROCESSED = "PROCESSED"
}

export const canAdminCheckReimbursementDetails = [
  ReimbursementStatus.PENDING_APPROVAL,
  ReimbursementStatus.APPROVED,
  ReimbursementStatus.REJECTED,
  ReimbursementStatus.PROCESSED
];

export default ReimbursementStatus;

export const PARTICIPANT_CAN_UPDATE_REIMBURSEMENT_DETAILS_ENUM = [
  ReimbursementStatus.NOT_COMPLETED,
  ReimbursementStatus.PENDING_APPROVAL
];

export const DISPLAY_PARTICIPANT_NOTE_STATUS_LIST = [
  ReimbursementStatus.APPROVED,
  ReimbursementStatus.PROCESSED,
  ReimbursementStatus.REJECTED
];
